<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">修改注册邮箱</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="企业名称"
                  required
                  :rules="rules.required"
                  v-model="item.enterName"
                />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="企业信用代码"
                  required
                  :rules="rules.required"
                  v-model="item.creditCode"
                />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="联系人"
                  required
                  :rules="rules.required"
                  v-model="item.contactName"
                />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="联系电话"
                  required
                  :rules="rules.phone"
                  v-model="item.contactTel"/>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="电子邮箱"
                  required
                  :rules="rules.email"
                  v-model="item.contactEmail"/>
              </v-flex>

              <v-flex xs12>
                <x-uploader
                  label="营业执照(请在单位营业执照复印件上加盖公章，扫描后上传。如不提供，不受理本次申请！)"
                  :action="fileUri"
                  :data="{group: 'credit'}"
                  :multiple="false"
                  v-model="item.credit"
                  :size="Number(10)"
                  hint="附件大小不能超过10M。"
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="备注"
                  v-model="item.note"
                />
              </v-flex>

            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <div class="text-xs-center" v-if="alert">
        <v-alert outline color="error" icon="warning" dismissible v-model="alert">
          数据输入不完整或数据格式错误，请检查后重新保存！
        </v-alert>
      </div>
      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false ;alert = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

  import mixin from '@/mixin'

  import XUploader from '@/components/global/SingleUploader'

  const baseURI = '/api/login/reset/password';

  export default {
    mixins: [mixin.edit(baseURI)],

    components: {XUploader},

    data() {
      return {
        formValid: false,

        alert: false,

        fullscreen: false,

        fileUri: '/api/task/file',

        item: {
          "dbid": null,
          "creditCode":null,
          "contactEmail":null,
          "enter": {},
          "credit": {}
        },

        freshItem: {
          "dbid": null,
          "creditCode":null,
          "contactEmail":null,
          "enter": {},
          "credit": {}
        },

        grantDateMenu: false,


        /**
         * 验证规则
         */
        rules: {
          required: [
            v => !!v || '必填项。'
          ],
          text800: [
            v => !!v || '必填项。',
            v => (v && v.length <= 800) || '长度必须小于800个字符。'
          ],
          text1000: [
            v => !!v || '必填项。',
            v => (v && v.length <= 1000) || '长度必须小于1000个字符。'
          ],
          text100: [
            v => !!v || '必填项。',
            v => (v && v.length <= 100) || '长度必须小于100个字符。'
          ],
          text200: [
            v => !!v || '必填项。',
            v => (v && v.length <= 200) || '长度必须小于200个字符。'
          ],
          phone: [
            v => !!v || '必填项。',
            v => (v && v.length < 20) || "长度不能超过 20 个字符。",
            v => (v && /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/ig.test(v)) || '电话号码格式不正确。'
          ],
          email: [
            v => !!v || '必填项。',
            v => (!v || v.trim().length === 0 || /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/ig.test(v)) || '邮箱格式不正确'
          ],
          decimal: [
            v => (!!v || v === 0) || '必填项。',
            v => ((v && /^(\-|\+)?\d+(\.\d{1,2})?$/g.test(v)) || v === 0) || '请输入数字（可保留两位小数）。'
          ],
          year: [v => !!v || '必填项。'],
          note: [v => (v && v.length <= 255) || '长度必须小于255个字符。'],
          startDate: [v => !!v || '必填项。'],
          endDate: [
            v => !!v || '必填项。',
            v => (v && v > this.item.startDate) || '项目结束时间要大于项目开始时间。'
          ]
        }
      }
    },


    created() {
    },

    watch: {},

    methods: {
      //保存前调用
      beforeSave() {
        if (!this.$refs.formRef.validate())
          this.alert = true
      },

      // mixin 加载数据后调用
      afterGetData(data) {
        this.alert = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/task/Password/Edit.vue